<template>
  <el-header height="48px">
    <div class="t-city_select">
      <el-select
        v-if="mode === 'home'"
        placeholder="请选择"
        filterable
        size="small"
        :value="lc"
        @input="handleChangeLc"
      >
        <el-option
          v-for="item in lclist"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="t-info_bar">
      <el-select class="t-info_bar-type" size="small" v-model="searchType" placeholder="请选择" @input="changeSearchType">
        <el-option label="订单号" :value=1></el-option>
        <el-option label="骑手名" :value=2></el-option>
      </el-select>
      <el-autocomplete
        size="small"
        popper-class="t-info_bar-search-popper"
        class="t-info_bar-search"
        clearable
        :debounce=0
        prefix-icon="el-icon-search"
        :trigger-on-focus="true"
        :fetch-suggestions="querySearch"
        @select="handleSelect"
        @blur="handleBlur"
        @focus="handleFocus"
        v-model="searchText">
          <template slot-scope="{ item }">
            <div class="order_no" v-if="item.type === 'order'">{{ item.value }}</div>
            <div class="rider_name" v-if="item.type === 'rider'">{{ item.value }}</div>
            <div v-if="item.type === 'noData'">无数据</div>
          </template>
          <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
        </el-autocomplete>
      <span class="t-info_bar-user">
        {{userName}}（{{phone}}）
      </span>
    </div>
  </el-header>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import { Message } from 'element-ui';
import { setCookie } from 'common/utils';
import { getbasicdata, searchrider, searchorder } from '../api';
import { UPDATE_LC, UPDATE_DATE } from '../pages/homepage/store/mutation-types';

export default {
  name: 'TravellerHeader',
  data() {
    return {
      searchType: 1, // 默认搜索类
      searchText: '',
      queryResult: [],
      userName: '',
      phone: '',
    };
  },
  props: {
    mode: {
      type: String, // 首页：'home' , 订单模式：'order' , 骑手模式：'rider'
      default: 'home',
    },
  },
  computed: {
    ...mapState([
      'lc',
    ]),
    ...mapState({
      timestamp: state => state.timestamp,
    }),
    ...mapGetters([
      'lclist',
    ]),
  },
  mounted() {
    getbasicdata().then((data) => {
      if (data.errno === 0 || data.errno === '0') {
        if (data.dataAuth) {
          this.userName = data.dataAuth.chinesename;
          this.phone = data.dataAuth.phone;
        }
      }
    });
  },
  methods: {
    ...mapMutations({
      updateLc: UPDATE_LC,
      updateDate: UPDATE_DATE,
    }),
    ...mapActions('riderList', [
      'getRiderListData',
    ]),
    ...mapActions([
      'requestAoiShopList',
    ]),
    changeSearchType() {
      this.searchText = '';
      this.queryResult = [];
    },
    handleChangeLc(lc) {
      setCookie('logisticsCenter', lc);
      this.updateLc(lc);
      console.log(lc);
      this.requestAoiShopList();
    },
    querySearch(queryString, cb) {
      if (this.searchType === 1) {
        // 搜索订单号
        this.queryResult = this.searchOrder(queryString);
      } else if (this.searchType === 2) {
        // 搜索骑手name
        this.queryResult = this.searchRider(queryString);
      }
      cb(this.queryResult);
    },
    searchOrder(query) {
      const result = [];
      if (query.length > 7) {
        // 去掉空格
        const q = query.replace(/\s+/g, '');
        searchorder({ order_id: q }).then((data) => {
          const { list } = data.data;
          if (list.length > 0) {
            list.forEach((row) => {
              result.push({
                ...row,
                value: row.order_id,
                type: 'order',
              });
            });
          } else {
            result.push({ type: 'no-data' });
          }
        });
      }
      return result;
    },
    searchRider(query) {
      const result = [];
      if (query.length > 0) {
        searchrider({ name: query }).then(({ data }) => {
          const { list } = data;
          if (list.length > 0) {
            list.forEach((row) => {
              result.push({
                ...row,
                value: row.chinesename,
                type: 'rider',
              });
            });
          } else {
            result.push({ type: 'noData' });
          }
        });
      }
      return result;
    },
    handleSelect(selected) {
      if (selected.type === 'order') {
        if (selected.order_supplier_type === 2) {
          Message({
            message: '外部供应商订单无法跳转订单时光机',
            type: 'error',
          });
          return;
        }
        // 打开订单时光机
        const time = selected.distribute_time ? selected.distribute_time : selected.list_time;
        const href = `orderview.html#/order/${selected.order_id}/${time}`;
        window.open(href);
      } else if (selected.type === 'rider') {
        // 打开骑手时光机
        const href = `rider.html?ridername=${selected.chinesename}#/rider/ordermode/${selected.rider_id}/${this.timestamp}`;
        window.open(href);
      }
    },
    handleBlur() {
      this.searchText = '';
      this.queryResult = [];
    },
    handleFocus() {

    },
  },
};
</script>

<style lang="less">
.el-header {
  background: #fff;
  box-sizing: border-box;
  opacity: 0.8;
  position: absolute;
  top: 0;
  left: 156px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #666;
  font-size: 12px;
  z-index: 1000;
  transition: 0.3s;
  width: calc(100% - 156px);

  &:hover {
    opacity: 1;
  }

  .t-city_select {
    width: 120px;
  }

  .t-info_bar {
    display: flex;
    align-items: center;

    &-type {
      width: 90px;
      margin-right: 8px;
    }

    &-search {

      .el-input__inner {
        width: 212px;
      }

      .el-input-group__prepend {
        background-color: #fff;
        width: 52px;

        .el-input__inner {
          width: 90px;
        }
      }

      .el-input-group__append {
        background-color: #fff;
      }

      &-popper {
        line-height: normal;
        padding: 7px;
        width: auto;
      }
    }

    &-user {
      margin-left: 32px;
      white-space: nowrap;
      font-size: 14px;
      color: #666666;
    }
   
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TravellerHeader.vue